import { render, staticRenderFns } from "./CancellationDetailPrescriptionComponent.vue?vue&type=template&id=a71c3222"
import script from "./CancellationDetailPrescriptionComponent.vue?vue&type=script&lang=js"
export * from "./CancellationDetailPrescriptionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports